import { IPostQuestionPayload } from '../../api/public/discuss-api';
import { PaginationCTAType } from '../../shared/public/SlPagination/types';

export interface IAction {
	type: ActionType;
	requestType?: RequestType;
	data?: IActionData;
}

export enum ActionType {
	// Mount events
	OnDiscussQuestionMount,
	OnDiscussQuestionUnMount,
	OnDiscussRepliesMount,
	OnDiscussRepliesUnMount,
	OnHotTodayMount,
	OnDiscussQuestionsListMount,
	OnDiscussQuestionsListPageMount,
	OnCreateEditQuestionMount,
	OnCreateEditQuestionUnMount,
	OnPostQuestionModalMount,

	// Click events
	OnPositiveReactionClick,
	OnReplySaveClick,
	OnAnswerButtonClick,
	OnCreateReplyCancelClick,
	OnCloseSaveReplySuccessMessage,
	OnBestAnswerButtonClick,
	OnProfileButtonClick,
	OnQuestionClick,
	OnTopicClick,
	OnTagClick,
	OnSearchClick,
	OnAskAQuestionClick,
	OnPaginationClick,
	OnEmptyQuestionCTAClick,
	OnQuestionSubmit,
	OnQuestionPostCancelClick,
	OnQuestionDeleteClick,
	OnPostQuestionModalCloseClick,
	OnSeeAllCoursesClick,
	OnRecommendedCourseClick,
	OnQuestionDeleteModalCloseClick,
	OnQuestionDeleteModalDeleteClick,
	OnReplyDeleteModalCloseClick,
	OnReplyDeleteModalDeleteClick,
	OnQuestionEditClick,
	OnJumpLinkClick,
	OnReplyEditButtonClick,
	OnDeleteReplyClick,

	// Input events
	OnPostTagInputChange,

	// Business actions
	GetDiscussReplies,
	GetDiscussQuestion,
	GetQuestionsList,
	UpdatePositiveReaction,
	CreateReply,
	GetHotTodayTopics,
	ToggleAcceptedAnswer,
	TriggerCreateReplySuccessMessageVisibility,
	TriggerEditReplySuccessMessageVisibility,
	TriggerReplyFormVisibility,
	TriggerNotificationVisibility,
	QuestionFilterChange,
	PostQuestion,
	EditQuestion,
	DeleteQuestion,
	GetTags,
	EditReply,
	DeleteReply,

	// Tracking
	Track,
}

export enum RequestType {
	Parallel,
	Cancelable,
	Sequential,
}

export interface IActionData {
	trackData?: ITrackActionData;
	questionId?: string;
	questionAlias?: string;
	postId?: string;
	sortType?: number;
	replyContent?: string;
	questionsListSearchText?: string;
	questionsListFilter?: string;
	isReplyFormOpen?: boolean;
	isCreateReplySuccessMessageVisible?: boolean;
	isEditReplySuccessMessageVisible?: boolean;
	currentPageNumber?: number;
	replyId?: number;
	userId?: number;
	alias?: string;
	pageNumber?: number;
	pageAlias?: string;
	id?: number;
	searchedInputValue?: string;
	ctaType?: MainCTAType;
	ctaURL?: string;
	text?: string;
	linkClickSource?: LinkClickSource;
	clickedPageNumber?: number;
	paginationCtaType?: PaginationCTAType;
	selectedFilter?: string;
	postQuestionPayload?: IPostQuestionPayload;
	tagInput?: string;
	questionPageType?: QuestionPageType;
}

export enum TrackActionName {
	OnDiscussPageMount = 'onDiscussPageMount',
	OnPostClick = 'onPostClick',
	OnNewQuestionMount = 'onNewQuestionMount',
	OnEditQuestionMount = 'onEditQuestionMount',
	OnPostQuestionModalMount = 'onPostQuestionModalMount',
	OnTagClick = 'onTagClick',
	OnSearchClick = 'onSearchClick',
	OnCTAClick = 'onCTAClick',
	OnPaginationClick = 'onPaginationClick',
	QuestionFilterChange = 'questionFilterChange',
	OnCourseClick = 'onCourseClick',
	OnJumpLinkClick = 'onJumpLinkClick',
}

export interface ITrackActionData {
	actionName: TrackActionName;
	questionId?: string;
	pageAlias?: string;
	clickPostId?: string;
	source?: string;
	postId?: string;
	tagAlias?: string;
	ctaType?: string;
	pageNumber?: number;
	clickPageNumber?: number;
	searchText?: string;
	sectionName?: string;
	materialId?: string;
	experienceAlias?: string;
	linkClickSource?: LinkClickSource;
	hyperText?: string;
	hyperLink?: string;
}
export enum MainCTAType {
	AskQuestion = 'ASK_QUESTION',
	GoToQuestion = 'GO_TO_QUESTION',
	SignIn = 'SIGN_IN',
	TryAgain = 'TRY_AGAIN',
	Answer = 'ANSWER',
	Cancel = 'CANCEL',
	PostQuestion = 'POST_QUESTION',
	Course = 'COURSE',
	AllCourses = 'ALL_COURSES',
	Edit = 'EDIT',
	Delete = 'DELETE',
	Save = 'SAVE',
}

export interface ISelectedTags {
	label: string;
	value: string;
}

export enum QuestionPageType {
	New,
	Edit,
}

export enum LinkClickSource {
	TITLE = 'TITLE',
	DESCRIPTION = 'DESCRIPTION',
	ANSWER = 'ANSWER',
}
